export const analytics = (analyticsData, shouldAutoClear = true) => {
    const dataLayer = window.dataLayer || [];
    dataLayer.push(Object.assign(Object.assign({}, analyticsData), { _clear: shouldAutoClear }));
};
export const triggerLogOutGTMEvent = () => {
    const analyticsData = {
        event: "visitor interaction",
        interactionName: "log out",
        successFlag: "success",
        authStatus: "logged out",
        authHavenId: null,
        authId: null,
        productType: "my_account",
        errorType: "no error",
    };
    analytics(analyticsData, false);
};
